var map = {
	"./242944_on.png": 3401,
	"./2_on.png": 6270,
	"./5003611_on.png": 6728,
	"./5004216_on.png": 9350,
	"./5004997_on.png": 9648,
	"./5005114_on.png": 6976,
	"./default_on.png": 1801,
	"./point_on.png": 5618,
	"./spec_on.png": 3753,
	"./tapian_on.png": 5853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2937;